import httpcommon from "../httpcommon";
import adlogin from '../adlogin'
import axios from "axios";
import { encryptData } from "../../components/common/encryptDecrypt"
import httpcommon1 from "../HttpCommon2";
import httpcommon3 from "../httpCommon3"

class ApiService {
    // Returns the list of screens a given user is allowed to see
    // (used to build the side navigation dynamically). Each item looks like:
    // { id, userId, screen, screenName, status, ... } — only status === 1
    // entries should be treated as visible.
    async getLoginWorkflowConfig(userId) {
        if (!userId) return null;
        try {
            const response = await httpcommon3.get(`api/lab/login-workflow/config?userId=${userId}`);
            if (response?.status === 200) {
                return response;
            }
            return null;
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getToken(formData) {
        console.log(formData)
        formData.grant_type = 'password'
        delete formData.userMobileNumber
        delete formData.userOTP
        let payload = {
            userCode: formData.userCode,
            passWord: globalThis.btoa(formData.passWord),
            channel: 'W'
        }

        const encryptedData = encryptData(payload)
        return httpcommon3.post('gcp/oauth/token', encryptedData)
    }

    async loginApi(formData) {
        const parsedFormData = JSON.parse(formData);

        const filteredFormData = Object.fromEntries(
            Object.entries(parsedFormData).filter(([key, value]) => value !== undefined && value !== null && value !== '')
        );
        if (filteredFormData.passWord) {
            filteredFormData.passWord = btoa(filteredFormData.passWord);
            filteredFormData.roleCode = 'DIAG'
        }
        console.log(formData)
        delete filteredFormData.grant_type

        let payload = encryptData(filteredFormData)

        try {
            const response = await httpcommon3.post('Login/withOutAd', payload);

            if (response?.status === 200) {
                return response;
            } else {
                console.error('API Error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async logincbayuser(formData) {
        const parsedFormData = JSON.parse(formData);

        const filteredFormData = Object.fromEntries(
            Object.entries(parsedFormData).filter(([key, value]) => value !== undefined && value !== null && value !== '')
        );
        if (filteredFormData.passWord) {
            filteredFormData.passWord = btoa(filteredFormData.passWord);
        }

        try {
            const response = await httpcommon.post('Login/withAd', JSON.stringify(filteredFormData));
            console.log(response)
            if (response?.status === 200) {
                return response;
            } else {
                console.error('API Error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async adloginApi(formData) {
        const parsedFormData = formData

        const filteredFormData = Object.fromEntries(
            Object.entries(parsedFormData).filter(([key, value]) => value !== undefined && value !== null && value !== '')
        );
        if (filteredFormData.passWord) {
            filteredFormData.password = filteredFormData.passWord
        }
        filteredFormData.username = filteredFormData.userCode
        delete filteredFormData.userCode
        delete filteredFormData.passWord
        try {
            const response = await adlogin.post('https://adapi-stage.curebay.in/commonlogin/api/validateUser', JSON.stringify(filteredFormData));

            if (response?.status === 200) {
                return response;
            } else {
                console.error('API Error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async loginUsingMobile(formData) {
        const parsedFormData = JSON.parse(formData);
        if (parsedFormData.otp) {
            parsedFormData.passWord = btoa(parsedFormData.passWord);
        }

        try {
            const response = await httpcommon.post('/Login/UserLoginWithMobile/', JSON.stringify(parsedFormData));
            if (response?.status === 200) {
                return response;
            } else {
                console.error('API Error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async changePassword(formData) {
        try {
            const response = await httpcommon.post('/PasswordMaintenance/', formData);
            if (response?.status === 200) {
                return response;
            } else {
                console.error('API Error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }
    async forgetChangePassword(formData) {
        try {

            const response = await httpcommon3.post('/PasswordMaintenance/forgetpasswordchange', formData);

            if (response?.status === 200) {
                return response;
            } else {
                console.error('API Error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async sentFeedback(formData) {
        try {
            const response = await httpcommon.post('/Feedback/', formData);
            if (response?.status === 200) {
                return response;
            } else {
                console.error('API Error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async saveLab(formData) {
        try {
            const response = await httpcommon.post('hospital/', formData);
            if (response?.status === 200) {
                return response;
            } else {
                console.error('API Error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async updateLab(formData) {
        try {
            const response = await httpcommon.put('hospital/' + formData.id, formData);
            if (response?.status === 200) {
                return response;
            } else {
                console.error('API Error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async userInfo(userCode) {
        try {
            const searchParams = new URLSearchParams();
            searchParams.append('userId', userCode);
            searchParams.append('status', 1);
            const response = await httpcommon.get(`/User_Hospital_Location/list?${searchParams.toString()}`, {})
            if (response) {
                return response;
            }
            else {
                console.error('API Error:', response);
                return null;
            }
        }
        catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getHomeCR(payload) {
        try {
            const response = await httpcommon1.post(`patientLabTests`, payload)
            if (response) {
                return response;
            }
            else {
                console.error('API Error:', response);
                return null;
            }
        }
        catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getphleboAO(payload) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(payload);
            for (const key of filterKeys) {
                const value = payload[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon1.post(`phleboList?${searchParams.toString()}`)
            if (response) {
                return response;
            }
            else {
                console.error('API Error:', response);
                return null;
            }
        }
        catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async assignPhleboUser(payload) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(payload);
            for (const key of filterKeys) {
                const value = payload[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon1.post(`order/assign?${searchParams.toString()}`)
            if (response) {
                return response;
            }
            else {
                console.error('API Error:', response);
                return null;
            }
        }
        catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getOrderDetails(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails);
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon3.get(`api/v1/admin/LabTestsOrder/list?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async gettrackStatuses(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails);
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon3.get(`api/v1/rider/orderTracking/list?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async validManualId(filterDetails) {
        try {
            const response = await httpcommon.post(`/manualBooking/validation`, filterDetails);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async updateManualId(filterDetails) {
        try {
            const response = await httpcommon3.post(`/manualBooking/`, filterDetails);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async saveCorparate(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails);
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon3.post(`corporates`, filterDetails);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async updateCorporate(formData) {
        const { id, ...bodyData } = formData;

        const searchParams = new URLSearchParams();
        if (id !== undefined && id !== null) {
            searchParams.append('id', id);
        }

        try {
            const response = await httpcommon3.put(
                `corporates/${id.toString()}`,
                bodyData
            );
            if (response?.status === 200) {
                return response;
            } else {
                console.error('API Error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getPatientDetails(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails);
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon.get(`/patient/list/filter?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async b2bCount() {
        try {
            const response = await httpcommon.get(`/Dashboard/b2bAndB2CCount`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async failureBooking(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails);
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon.get(`Dashboard/listCountFailureBooking?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async labPartnerCount(details) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(details);
            for (const key of filterKeys) {
                const value = details[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon.get(`Dashboard/labPartnerCount?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async reportFailure(details) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(details);
            for (const key of filterKeys) {
                const value = details[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon.get(`Dashboard/listCountFailureReport?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getLabTestsOrderReport(details) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(details);
            for (const key of filterKeys) {
                const value = details[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon3.get(`/LabTestsOrderReport/list?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getPatientLabTestsOrderDetails(details) {
        try {
            const response = await httpcommon3.get(`api/v1/admin/LabTestsOrderDetail/${details}/tests`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getLabOrdersActiveDetails(orderId, params) {
        try {
            const response = await httpcommon3.get(`api/v1/lab-orders/${orderId}/details`, {
                headers: {
                    Accept: 'application/json'
                },
                ...(params && Object.keys(params).length > 0 ? { params } : {})
            });
            return response;
        } catch (error) {
            console.error('API Request Error (getLabOrdersActiveDetails):', error);
            return error?.response || null;
        }
    }

    async getPredLabOrderDetails(orderId, params) {
        return this.getLabOrdersActiveDetails(orderId, params);
    }

    async deleteLabOrderTest(payload) {
        try {
            const response = await httpcommon3.post(`api/v1/lab-orders/delete-test`, payload, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            });
            return response;
        } catch (error) {
            console.error('API Request Error (deleteLabOrderTest):', error);
            throw error;
        }
    }

    async cancelPredLabTest(payload) {
        return this.deleteLabOrderTest(payload);
    }

    async getStatelist(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails);
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon.get(`state/list?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async updateProfile(formData) {
        try {
            const response = await httpcommon.put(`user/${formData.id}`, formData);
            if (response?.status === 200) {
                return response;
            } else {
                console.error('API Error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async updateRemarks(formData) {
        try {
            const response = await httpcommon3.put(`api/v1/admin/LabTestsOrder/remark/${formData.orderId}`, formData);
            if (response?.status === 200) {
                return response;
            } else {
                console.error('API Error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async updateOrderStatus(formData) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(formData);
            for (const key of filterKeys) {
                const value = formData[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon3.put(`api/v1/admin/LabTestsOrder/updateOrderStatus?${searchParams.toString()}`);
            if (response?.status === 200) {
                return response;
            } else {
                console.error('API Error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getUserDetails(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails);
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon.get(`user/${filterDetails.code}`);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async uploadLabReports(payload, method) {
        const payload1 = {
            modifiedBy: payload[0].modifiedBy
        };

        try {
            let response;
            if (method === 'POST') {
                response = await httpcommon3.post('/LabTestsOrderReport/', payload);
            } else if (method === 'PUT') {
                response = await httpcommon3.put('/LabTestsOrderReport/delete/' + payload[0].id, payload1)
            } else {
                console.error('Invalid HTTP method:', method);
                return null;
            }
            if (response) {
                return response
            }
            else {
                console.error('API Error:', response);
                return null;
            }
        }
        catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async uploadLabReportsLog(payload) {
        try {
            const response = await httpcommon.post('/PatientLabReportLog/', payload);
            if (response) {
                return response
            }
            else {
                console.error('API Error:', response);
                return null;
            }
        }
        catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getNotification(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails);
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon.get(`notification/list/filter?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async postNotification(filterDetails) {
        try {
            const response = await httpcommon.post('/notification/', filterDetails);
            if (response?.status === 200) {
                return response;
            } else {
                console.error('API Error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async forgetPassword(filterDetails) {
        try {
            const response = await httpcommon3.post('PasswordMaintenance/forgetpassword/', filterDetails);
            if (response?.status === 200) {
                return response;
            } else {
                console.error('API Error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async patientLabTestsOrder(payload, method) {
        try {
            let response;
            if (method === 'POST') {
                response = await httpcommon.post('/PatientLabTestsOrder/', payload);
            } else if (method === 'PUT') {
                response = await httpcommon.put('/PatientLabTestsOrder/' + payload.orderId, payload);
            } else {
                console.error('Invalid HTTP method:', method);
                return null;
            }
            if (response) {
                return response
            }
            else {
                console.error('API Error:', response);
                return null;
            }
        }
        catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async updateLabPartner(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails);
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon.post(`/CCLabOrderFlow/`, filterDetails);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getsentMail(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails);
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon.get(`mails/listSentMailsFromUser?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getLabs(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails);
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon3.get(`api/v1/admin/LabDetail/list?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getCollectionList(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails || {});
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon3.get(`api/v1/admin/SMDetails/list?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getLabList(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails || {});
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon.get(`hospital/listAllLabName?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getCCList(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails || {});
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon3.get(`/dropdowns/labs?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }
    async getTRFdata(orderId) {
        try {

            const response = await httpcommon3.get(`GenerateTrf/list/getReport?orderId=${orderId}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getLabOrderDetails(orderId) {
        try {

            const response = await httpcommon3.get(`/patientLabTestsOrderDetails/list-orderId?orderId=${orderId.orderId}&&isCategory=${orderId.isCategory}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }
    async getCircleList(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails || {});
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon.get(`CircleMaster/list/filter?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getphelboUserList(filterDetails) {
        try {
            const response = await httpcommon3.get(`admin/phlebo/list`, filterDetails);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getCorporatelist(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails || {});
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon3.get(`corporates`, filterDetails);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async exportOrders(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails);
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon3.get(`export/download/LabTestsOrder?${searchParams.toString()}`, {
                responseType: 'blob'
            });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }
    async reportBulkDownload(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails);
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon3.get(`LabTestsOrderReport/download-reports?${searchParams.toString()}`, {
                responseType: 'blob'
            });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }
    async getmappingList(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails || {});
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon3.get(`mapToMobilab/list?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async dashOrderStatus(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails || {});
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon3.get(`admin/dashboard/list?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async dashOverview(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails || {});
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon3.get(`admin/dashboard/order-overview?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async dashinflowWeek(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails || {});
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon3.get(`admin/dashboard/order-inflow?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async dashinflowMonth(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails || {});
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon3.get(`admin/dashboard/order-inflow-monthly?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async dashOrderAging(filterDetails) {
        return this.dashOrderStatus(filterDetails);
    }

    async gethomecollectionRequest(filterDetails) {
        try {
            const response = await httpcommon.post(`mapToMobilab/list`, filterDetails);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getmoblilabUsersList(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails || {});
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon3.get(`/mapToMobilab/userList?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getCCBulkUploads(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails);
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon3.get(`/OrderExcelUpload/list?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async CCbulkupload(payload) {
        try {
            const response = await httpcommon3.post(`OrderExcelUpload/`, payload);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async saveMapping(payload) {
        try {
            const response = await httpcommon3.post(`mapToMobilab/save`, payload);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async addMobiUser(payload) {
        try {
            const response = await httpcommon3.post(`/mapToMobilab/mobilabUserCreation`, payload);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async updateMobiuser(payload) {
        try {
            const response = await httpcommon3.post(`/mapToMobilab/mobilabUserUpdate`, payload);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async deleteMapping(payload) {
        try {
            const response = await httpcommon3.post(`mapToMobilab/delete`, payload);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getmobiUserList(filterDetails) {
        try {
            const response = await httpcommon3.post(`mapToMobilab/mobilabUserList`);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getInboxMail(filterDetails) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(filterDetails);
            for (const key of filterKeys) {
                const value = filterDetails[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon.get(`mails/listInboxMailsForUser?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getCountDetails(details) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(details);
            for (const key of filterKeys) {
                const value = details[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon.get(`/LabDashboard/listCount?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async postMails(filterDetails) {
        try {
            const response = await httpcommon.post('/mails/', filterDetails);
            if (response?.status === 200) {
                return response;
            } else {
                console.error('API Error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getLabOrderGraphDetails(details) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(details);
            for (const key of filterKeys) {
                const value = details[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon.get(`/LabDashboard/newUploadPendingCount?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getLabOrderGraphDetails2(details) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(details);
            for (const key of filterKeys) {
                const value = details[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon.get(`/LabDashboard/newPathologyRadiologyCount?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async getSLAComplianceGraphDetails(details) {
        try {
            const searchParams = new URLSearchParams();
            const filterKeys = Object.keys(details);
            for (const key of filterKeys) {
                const value = details[key];
                if (value !== undefined && value !== null) {
                    searchParams.append(key, value);
                }
            }
            const response = await httpcommon.get(`/LabDashboard/newSLACount?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async generateOtp(payload) {
        try {
            const response = await httpcommon.post(`UserOTP/generateUserOTP/${payload.mobileNumber}/${payload.mobileCheck}`);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        }
        catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }
    async getSmartReports(payload) {
        try {
            const response = await httpcommon3.get(`api/v1/smart-reports/order/${payload.orderId}`);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        }
        catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }
     async getReportsLogs(payload) {
        try {
            const response = await httpcommon3.get(`LabTestsOrderReport/logs/by-order?orderId=${payload.orderId}`);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        }
        catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }
    async getCrelioPacsDetails(orderId) {
        try {
            const id = typeof orderId === 'object' ? orderId?.orderId : orderId;
            const response = await httpcommon3.get(`api/v1/crelio/pacs/${id}`);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        }
        catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }
    async getlabsByType(payload) {
        try {
            const searchParams = new URLSearchParams();
            searchParams.append('type', payload.type
            );

            const response = await httpcommon3.get(`dropdowns/lab/list?${searchParams.toString()}`, {});
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        }
        catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }
    async getUserConsent() {
        try {
            const configurationObject = {
                method: 'GET',
                url: process.env.REACT_APP_CMS_VERSION_URL,
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            };
            const response = await axios(configurationObject);
            return response.data;
        } catch (error) {
            console.log('Warning', error);
            return error.response;
        }
    }

    async getApiCMS(id) {
        const NewCmsToken = 'Bearer 6f1797939dbb00599d8896d29f4e114b257e1e252d6856294951bdcdd7be292b7b49d6a266f2319d74e024cac8a99de3ab5256b82e25d4bb931a5c44a28f8d5ddcdffc51ee8abad8f62ac14a985397c4636b7575a9709d1cd6ae4bed4419494c2ea96ed3bc6223a5bac20e6a07342f7f17fb1cc7c87dccd85c0de0930896afe1'
        try {
            const configurationObject = {
                method: 'GET',
                url: process.env.REACT_APP_USER_CMS_URL + `&userId=${id}`,
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: NewCmsToken,
                },
            };
            const response = await axios(configurationObject);
            return response.data;
        } catch (error) {
            console.log('Warning', error);
            return error.response;
        }
    }

    async userConsentPost(payload) {
        const s_token = localStorage.getItem('access_token');

        try {
            const configurationObject = {
                method: 'POST',
                url: process.env.REACT_APP_USER_ADDCONSENT,
                data: payload,
                headers: {
                    Authorization: `Bearer ${s_token}`
                }
            };
            const response = await axios(configurationObject);
            return response.data;
        } catch (error) {
            console.error('Warning', error);
        }
    }
    // Add these methods to the ApiService class in actions.js

async getMobilabClinicList(filterDetails = {}) {
    try {
        const searchParams = new URLSearchParams();
        const filterKeys = Object.keys(filterDetails);
        for (const key of filterKeys) {
            const value = filterDetails[key];
            if (value !== undefined && value !== null) {
                searchParams.append(key, value);
            }
        }
        const response = await httpcommon3.get(`mobilab2/clinic?${searchParams.toString()}`, {});
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return null;
        }
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}
async deleteMobilabClinic(id) {
    try {

        const response = await httpcommon3.delete(`mobilab2/clinic/${id}`);
        http://localhost:9050/diagnostic/mobilab2/clinic/MOB12345%27
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return null;
        }
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}
async getEclinicDropdown(searchKey = '') {
    try {
        const response = await httpcommon3.get(`api/v1/mobilab/eclinic-dropdown?searchKey=${searchKey}`, {});
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return null;
        }
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}
async getCollectionCenterDropdown(searchKey = '') {
    try {
        const response = await httpcommon3.get(`api/v1/mobilab/cc-dropdown?searchKey=${searchKey}`, {});
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return null;
        }
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}

async getMobilabHospitalUsers(filterDetails) {
    try {
             const searchParams = new URLSearchParams();
        const filterKeys = Object.keys(filterDetails);
        for (const key of filterKeys) {
            const value = filterDetails[key];
            if (value !== undefined && value !== null) {
                searchParams.append(key, value);
            }
        }
        const response = await httpcommon3.get(`api/v1/mobilab/hospital-users?${searchParams.toString()}`, {});
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return null;
        }
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}
async getCollectionUser(collectionCenter) {
    try {

        const response = await httpcommon3.get(`/api/v1/mobilab/cc-users/${collectionCenter}?searchKey=${''}`);
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return null;
        }
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}
async getMobilabRegisterUsers(filterDetails) {
    try {
             const searchParams = new URLSearchParams();
        const filterKeys = Object.keys(filterDetails);
        for (const key of filterKeys) {
            const value = filterDetails[key];
            if (value !== undefined && value !== null) {
                searchParams.append(key, value);
            }
        }
        const response = await httpcommon3.get(`/mobilab2/user/all?${searchParams.toString()}`, {});
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return null;
        }
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}
async saveMobilabClinic(payload) {
    try {
        const response = await httpcommon3.post(`mobilab2/clinic`, payload);
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return response;
        }
    } catch (error) {
        console.error('API Request Error:', error);
    }
}

async updateMobilabClinic(id, payload) {
    try {
        const response = await httpcommon3.put(`mobilab2/clinic/${id}`, payload);
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return null;
        }
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}

// Add these methods to the ApiService class

// Create User
async createMobilabUser(payload) {
    try {
        const response = await httpcommon3.post(`mobilab2/user`, payload);
        return response;
    } catch (error) {
        console.error('API Request Error:', error);
        if (error.response) {
            // Server responded with an error status (e.g. 400) — return it so the caller can read the message
            return error.response;
        }
        // No response at all (network error, timeout, etc.)
        return null;
    }
}

// Update User
async updateMobilabUser(id, payload) {
    try {
        const response = await httpcommon3.patch(`mobilab2/user/${id}`, payload);
            return response;
     
    } catch (error) {
            console.error('API Request Error:', error);
        if (error.response) {
            // Server responded with an error status (e.g. 400) — return it so the caller can read the message
            return error.response;
        }
        // No response at all (network error, timeout, etc.)
        return null;
    
    }
}

// Delete User
async deleteMobilabUser(id) {
    try {
        const response = await httpcommon3.delete(`mobilab2/user/${id}`);
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return null;
        }
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}

// List Users
async getMobilabUsers(filterDetails = {}) {
    try {
        const searchParams = new URLSearchParams();
        const filterKeys = Object.keys(filterDetails);
        for (const key of filterKeys) {
            const value = filterDetails[key];
            if (value !== undefined && value !== null && value !== '') {
                searchParams.append(key, value);
            }
        }
        const response = await httpcommon3.get(`mobilab2/user?${searchParams.toString()}`, {});
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return null;
        }
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}
async getEclinicDropdownUser(searchKey = '') {
    try {
        const response = await httpcommon3.get(`api/v1/mobilab/clinic-dropdown`, {});
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return null;
        }
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}
async getTracking(orderId) {
    try {
        const response = await httpcommon3.get(`patientLabTestsOrder/patientTrack/${orderId}`);
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return null;
        }
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}


async getLabPartners(date) {
    try {
        const searchParams = new URLSearchParams();
        if (date) searchParams.append('date', date);
        const response = await httpcommon3.get(`api/labPartnerErrorLog/labPartners?${searchParams.toString()}`, {});
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return null;
        }
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}


async getLabPartnerErrorLogs(filterDetails) {
    try {
        const searchParams = new URLSearchParams();
        const cleanFilters = { ...(filterDetails || {}) };
        delete cleanFilters.keepDate;
        const filterKeys = Object.keys(cleanFilters);
        for (const key of filterKeys) {
            const value = cleanFilters[key];
            if (value !== undefined && value !== null && value !== '') {
                searchParams.append(key, value);
            }
        }
        const response = await httpcommon3.get(`api/labPartnerErrorLog/list?${searchParams.toString()}`, {});
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return null;
        }
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}

async markLabPartnerErrorLogHandled(payload) {
    try {
        const response = await httpcommon3.put(`api/labPartnerErrorLog/failureUpdated`, payload);
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return null;
        }
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}

async retryBooking(payload) {
    try {
        const response = await httpcommon3.post('api/v1/lims/ext-lab/support/retry-booking', payload, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        });
        return response;
    } catch (error) {
        console.error('API Request Error:', error);
        throw error;
    }
}
    async reassignEclinic(payload) {
        try {
            const response = await httpcommon3.post(`mobilab2/booking/reassign-clinic?orderId=${payload.orderId}&receivedCheId=${payload.receivedCheId}`);
            if (response) {
                return response;
            } else {
                console.error('API Error:', response);
                return null;
            }
        } catch (error) {
            console.error('API Request Error:', error);
            return null;
        }
    }

    async fetchMobilabReportPdf(payload) {
        try {
            const response = await httpcommon3.post('mobilab2/booking/report-pdf', payload, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            });
            return response;
        } catch (error) {
            console.error('API Request Error:', error);
            throw error;
        }
    }

    async validateLabRouting(payload) {
        try {
            const response = await httpcommon3.post('api/v1/admin/lab-routing/validate', payload, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            });
            return response;
        } catch (error) {
            console.error('API Request Error:', error);
            throw error;
        }
    }

    async requestLabRouting(payload) {
        try {
            const response = await httpcommon3.post('api/v1/admin/lab-routing/requests', payload, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            });
            return response;
        } catch (error) {
            console.error('API Request Error:', error);
            throw error;
        }
    }

    async getFinanceLabRoutingApprovals(params = {}) {
        try {
            const { status = 'PENDING', page = 0, size = 20 } = params;
            const queryParams = [];
            if (status) queryParams.push(`status=${encodeURIComponent(status)}`);
            queryParams.push(`page=${page ?? 0}`);
            queryParams.push(`size=${size ?? 20}`);
            const queryString = queryParams.join('&');
            const response = await httpcommon3.get(`api/v1/admin/lab-routing/finance/approvals?${queryString}`, {
                headers: {
                    Accept: 'application/json',
                },
            });
            return response;
        } catch (error) {
            console.error('API Request Error:', error);
            throw error;
        }
    }

    async approveFinanceLabRouting(routeReference, payload = {}) {
        try {
            const response = await httpcommon3.post(`api/v1/admin/lab-routing/${routeReference}/finance/approve`, payload, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            });
            return response;
        } catch (error) {
            console.error('API Request Error:', error);
            throw error;
        }
    }

    async rejectFinanceLabRouting(routeReference, payload = {}) {
        try {
            const response = await httpcommon3.post(`api/v1/admin/lab-routing/${routeReference}/finance/reject`, payload, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            });
            return response;
        } catch (error) {
            console.error('API Request Error:', error);
            throw error;
        }
    }
// Add these methods to your apiService object in actions/index.jsx

async sharingFailure(params) {
    try {
        const { date, page = 0, size = 20 } = params;
        const response = await httpcommon3.get('api/whatsapp-reports/failed-whatsapp', {
            params: { date, page, size }
        });
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return null;
        }
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}

async whatsappVendorFailure(params) {
    return this.sharingFailure(params);
}

async statusFailure(params) {
    try {
        const { date, page = 0, size = 20 } = params;
        const response = await httpcommon3.get('api/whatsapp-reports/pending-reports', {
            params: { date, page, size }
        });
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return null;
        }
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}
// Only used to REACTIVATE an inactive clinic/collection center
async activateMobilabClinic(id) {
    try {
        const response = await httpcommon3.put(`mobilab2/clinic/${id}/status?isActive=1`, { isActive: 1 });
        if (response) {
            return response;
        } else {
            console.error('API Error:', response);
            return null;
        }
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}
// ---- Collection Center Onboarding ----

async onboardBasicDetails(payload) {
    try {
        const response = await httpcommon3.post('collection-center/onboard/basic-details', payload);
        return response || null;
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}

async onboardAdminUser(payload) {
    try {
        const response = await httpcommon3.post('collection-center/onboard/user', payload);
        return response || null;
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}

async onboardLabMapping(payload) {
    try {
        const response = await httpcommon3.post('collection-center/onboard/lab-mapping', payload);
        return response || null;
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}

async uploadKycDocument(payload) {
    // payload: { collectionCenterCode, userCode, documentCategory, docType, docBytes }
    try {
        const response = await httpcommon3.put('collection-center/upload-document', payload);
        return response || null;
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}

async submitCCApproval(centerCode, payload) {
    try {
        const response = await httpcommon3.put(`collection-center/${centerCode}/approval`, payload);
        return response || null;
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}

async getCCAllDetails(centerCode) {
    try {
        const response = await httpcommon3.get(`collection-center/all-details/${centerCode}`, {});
        return response || null;
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}

async filterCollectionCenters(filterDetails) {
    try {
        const searchParams = new URLSearchParams();
        Object.keys(filterDetails || {}).forEach((key) => {
            const value = filterDetails[key];
            if (value !== undefined && value !== null) searchParams.append(key, value);
        });
        const response = await httpcommon3.get(`collection-center/filter?${searchParams.toString()}`, {});
        return response || null;
    } catch (error) {
        console.error('API Request Error:', error);
        return null;
    }
}

async getOnboardingConfigUsers({ search = '', roleCode = 'DIAGGROUPADMIN', page = 0, size = 50 } = {}) {
    try {
        const queryParams = new URLSearchParams();
        if (search) queryParams.append('search', search);
        if (roleCode) queryParams.append('roleCode', roleCode);
        if (page !== undefined) queryParams.append('page', page);
        if (size !== undefined) queryParams.append('size', size);
        const qs = queryParams.toString() ? `?${queryParams.toString()}` : '';
        const response = await httpcommon3.get(`onboarding-config/users${qs}`);
        return response || null;
    } catch (error) {
        console.error('API Request Error in getOnboardingConfigUsers:', error);
        return null;
    }
}

async getUserWorkflowConfig(userCode) {
    try {
        const response = await httpcommon3.get(`onboarding-config/user/${userCode}`);
        return response || null;
    } catch (error) {
        console.error('API Request Error in getUserWorkflowConfig:', error);
        return null;
    }
}

async saveOnboardingWorkflowConfig(payload) {
    try {
        const response = await httpcommon3.post(`onboarding-config/user`, payload);
        return response || null;
    } catch (error) {
        console.error('API Request Error in saveOnboardingWorkflowConfig:', error);
        return null;
    }
}

    async getDocumentUrls(filePaths) {
        const paths = Array.isArray(filePaths) ? filePaths : [filePaths];
        const cleanedPaths = paths.map(cleanGcpFilePath).filter(Boolean);
        if (cleanedPaths.length === 0) return null;

        const endpoint =
            process.env.REACT_APP_DOCUMENT_URL ||
            "https://utility-service-staging-1016738952353.asia-south1.run.app/api/gcp/document-urls";
        try {
            const response = await axios.post(
                endpoint,
                { filePaths: cleanedPaths },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("API Request Error in getDocumentUrls:", error);
            return null;
        }
    }

    async getDocumentUrl(filePath) {
        if (!filePath || typeof filePath !== "string") return null;
        if (
            filePath.startsWith("blob:") ||
            filePath.startsWith("data:") ||
            filePath.includes("X-Goog-Signature")
        ) {
            return filePath;
        }
        const cleanPath = cleanGcpFilePath(filePath);
        if (!cleanPath) return null;
        const res = await this.getDocumentUrls([cleanPath]);
        const fileItem = res?.FILES?.[0];
        return fileItem?.signedUrl || null;
    }

    async getPatientClinicalHistory(patientCode) {
        try {
            const response = await httpcommon3.get(`patient-clinical-history/List?patientCode=${encodeURIComponent(patientCode)}`);
            return response;
        } catch (error) {
            console.error('API Request Error (getPatientClinicalHistory):', error);
            return error?.response || null;
        }
    }

    async getSampleActionTrail(orderId, patientCode = "", page = 0, size = 20) {
        try {
            let pCode = "";
            let pNum = 0;
            let pSize = 20;

            if (typeof patientCode === "number") {
                pNum = patientCode;
                pSize = page || 20;
            } else {
                pCode = patientCode || "";
                pNum = page || 0;
                pSize = size || 20;
            }

            let url = `api/v1/che/SampleActionTrail?orderId=${encodeURIComponent(orderId)}`;
            if (pCode) {
                url += `&patientCode=${encodeURIComponent(pCode)}`;
            }
            url += `&page=${pNum}&size=${pSize}`;

            const response = await httpcommon3.get(url);
            return response;
        } catch (error) {
            console.error('API Request Error (getSampleActionTrail):', error);
            return error?.response || null;
        }
    }

    async addSampleActionTrail(payload) {
        try {
            const response = await httpcommon3.post('api/v1/admin/SampleActionTrail', payload);
            return response;
        } catch (error) {
            console.error('API Request Error (addSampleActionTrail):', error);
            return error?.response || null;
        }
    }
}

export const cleanGcpFilePath = (path) => {
    if (!path || typeof path !== "string") return "";
    let cleanPath = path.trim();
    cleanPath = cleanPath.replace(/^https?:\/\/storage\.googleapis\.com\/[^\/]+\/?/, "");
    cleanPath = cleanPath.replace(/^\/+/, "");
    cleanPath = cleanPath.split("?")[0];
    return cleanPath;
};

export const viewGcpDocument = async (filePath, onError) => {
    if (!filePath) {
        if (onError) onError("Document not available.");
        return;
    }
    if (
        filePath.startsWith("blob:") ||
        filePath.startsWith("data:") ||
        filePath.includes("X-Goog-Signature")
    ) {
        if (typeof window !== "undefined" && window.open) {
            window.open(filePath, "_blank");
        }
        return;
    }

    const cleanPath = cleanGcpFilePath(filePath);
    if (!cleanPath) {
        if (onError) onError("Invalid document path.");
        return;
    }

    const newTab = typeof window !== "undefined" && window.open ? window.open("", "_blank") : null;
    try {
        const response = await apiService.getDocumentUrls([cleanPath]);
        const fileItem = response?.FILES?.[0];
        if (fileItem?.signedUrl) {
            if (newTab) {
                newTab.location.href = fileItem.signedUrl;
            } else if (typeof window !== "undefined" && window.open) {
                window.open(fileItem.signedUrl, "_blank");
            }
        } else {
            if (newTab) newTab.close();
            const errorMsg = fileItem?.error || "Failed to retrieve document view link.";
            if (onError) onError(errorMsg);
        }
    } catch (error) {
        if (newTab) newTab.close();
        console.error("Error viewing document:", error);
        if (onError) onError("Failed to view document. Please try again later.");
    }
};

const apiService = new ApiService();
export default apiService;

export const checkIsLoggedIn = () => {
    const loginObjStr = localStorage.getItem('loginObj');

    try {
        const loginObj = JSON.parse(loginObjStr);
        const userCode = loginObj?.userSession?.userCode || null;
        return userCode;
    } catch (error) {
        console.error('Error parsing JSON:', error);
        return null;
    }
}